import React from "react";

const DefaultCell = ({ data, value }) => {
    return <div>{value}</div>;
};

export default DefaultCell;
